<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shipmentTracking-search-section"
        id="shipmentTracking-search-section"
      >
        <el-form
          id="shipmentTracking-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.consignee')">
                <autocomplete
                  :model.sync="searchForm.consigneeAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlConsignee"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  labelField="name"
                  valueField="id"
                  ref="filter-consigneeAccountId"
                  id="searchForm-consigneeAccountId"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.state')">
                <state-select v-model="searchForm.stateId" @change="handleSearch" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.city')">
                <autocomplete
                  :model.sync="searchForm.city"
                  popperAppendToBody
                  :url="cityUrl"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  labelField="name"
                  valueField="id"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.shipDateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.shipDateFrom"
                  format="MM/dd/yyyy"
                  type="date"
                  :clearable="false"
                  id="searchForm-shipDateFrom"
                  ref="filter-shipDateFrom"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :xs="24">
              <el-form-item :label="$t('outbound.loads.shipDateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  @change="handleSearch"
                  v-model="searchForm.shipDateTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-shipDateTo"
                  ref="filter-shipDateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                      :content="$t('common.search')"
                      class="item"
                      effect="dark"
                      placement="top-start"
              >
                <el-button
                        id="shipmentTracking-search-section-form-button"
                        class="button-action-default"
                        @click="handleSearch"
                        icon="el-icon-search"
                        size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import StateSelect from '@/components/StateSelect';

export default {
  name: 'ShipmentTrackingSearchSection',
  components: { Autocomplete, StateSelect },
  computed: {
    ...mapGetters(['loads']),
    cityUrl() {
      return apiConstants.END_POINTS.ROUTING.CITIES;
    }
  },
  data() {
    return {
      activeCollapsibleName: ['shipmentTracking-search-section'],
      isOpen: ['shipmentTracking-search-section'],
      searchForm: {
        consigneeAccountId: null,
        city: null,
        stateId: null,
        shipDateFrom: moment().add(-3, 'day').toDate(),
        shipDateTo: moment().toDate(),
        shipperAccountId: null
      },
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      statusOptions: [constants.STATUS_BOOLEAN.yes, constants.STATUS_BOOLEAN.no],
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('loads/searchShipmentTracking', this.searchForm);
    }
  },
  watch: {
    'searchForm.shipDateFrom': function updateShipTo(newVal) {
      const newFrom = moment(newVal);
      if (newFrom.isAfter(moment(this.searchForm.shipDateTo))) {
        this.searchForm.shipDateTo = newVal;
      }
    },
    'searchForm.shipDateTo': function updateShipFrom(newVal) {
      const newTo = moment(newVal);
      if (newTo.isBefore(moment(this.searchForm.shipDateFrom))) {
        this.searchForm.shipDateFrom = newVal;
      }
    }
  }
};
</script>
